import { render, staticRenderFns } from "./sideNotice.vue?vue&type=template&id=425bd85e&scoped=true&"
import script from "./sideNotice.vue?vue&type=script&lang=js&"
export * from "./sideNotice.vue?vue&type=script&lang=js&"
import style0 from "./sideNotice.vue?vue&type=style&index=0&id=425bd85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425bd85e",
  null
  
)

export default component.exports